import React, { Fragment } from "react"
import Tooltip from "@material-ui/core/Tooltip"
import { Typography } from "@material-ui/core"

const ListButton = ({ viewItemsBtn, setViewItemsBtn, setNeedToFilter }) => {
	return (
		<Tooltip
			title={
				<Fragment>
					<Typography color="inherit">Terms List view</Typography>
					{"View all original terms from your search."}
				</Fragment>
			}
			placement="bottom"
			arrow
		>
			<button
				data-cy="terms_list_button"
				onClick={(e) => {
					e.preventDefault()
					setViewItemsBtn("list")
					setNeedToFilter(true)
				}}
				className={
					viewItemsBtn === "list"
						? "btn btn-primary  btnViewsFilterBuild btn-small-filter"
						: "btn btn-outline-primary  btnViewsFilterBuild btn-small-filter"
				}
			>
				<i className="bi bi-list-ul"></i>
			</button>
		</Tooltip>
	)
}

export default ListButton
